module.exports = __webpack_public_path__ + "media/promo/courses/images/f3-7c7f2bd538128862e8ac442e68afea86.svg";